// extracted by mini-css-extract-plugin
export default {"loginForm":"Login_loginForm__85pq4","title":"Login_title__wb+Ua","warning":"Login_warning__YjmBH","loading":"Login_loading__YZ9V5"};